import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { BarChart3, TrendingUp, Clock, CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const AnalyticsPage = () => {
  const { API, accessToken } = useContext(AuthContext);
  const [analytics, setAnalytics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axios.get(`${API}/analytics/throughput`, { headers });
      setAnalytics(response.data);
    } catch (error) {
      toast.error('Failed to load analytics');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="analytics-page">
        <div>
          <h1 className="text-2xl sm:text-4xl font-bold text-gray-900">Analytics</h1>
          <p className="text-gray-600 mt-2">Performance metrics and insights</p>
        </div>

        {isLoading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="glass-effect border-none card-shadow">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Total Envelopes</CardTitle>
                <BarChart3 className="text-indigo-600" size={20} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold">{analytics?.total_envelopes || 0}</div>
                <p className="text-xs text-gray-500 mt-1">Last 30 days</p>
              </CardContent>
            </Card>

            <Card className="glass-effect border-none card-shadow">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">Completed</CardTitle>
                <CheckCircle className="text-green-600" size={20} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold">{analytics?.completed || 0}</div>
                <p className="text-xs text-gray-500 mt-1">Successfully signed</p>
              </CardContent>
            </Card>

            <Card className="glass-effect border-none card-shadow">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">In Progress</CardTitle>
                <Clock className="text-orange-600" size={20} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold">{analytics?.in_progress || 0}</div>
                <p className="text-xs text-gray-500 mt-1">Awaiting signatures</p>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default AnalyticsPage;